<template>
    <div class="titulo-procesos-section">
        <h2 class="titulo-procesos-title fuente-posm">
            Automatiza tus<br>Procesos de Ingresos
        </h2>
    </div>
</template>

<script>
export default {
    name: 'TituloProcesosNew'
}
</script>

<style lang="css" scoped>
.titulo-procesos-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    background-color: #272727;
}

.titulo-procesos-title {
    color: var(--color-5);
    font-size: 80px;
    line-height: 1.1;
    text-align: center;
    margin: 0;
    max-width: 950px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .titulo-procesos-title {
        font-size: 70px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .titulo-procesos-section {
        padding: 100px 20px 40px 20px;
    }

    .titulo-procesos-title {
        font-size: 35px;
    }
}
</style>
